import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import {
    defaultLanguage,
    supportedLanguages,
    toSupportedLanguage,
    type SupportedLanguage,
} from './language-config.ts';
import { resources } from './resources/resources.ts';

if (typeof window !== 'undefined') {
    // Legacy keys from when the language choice lived in this browser:
    // 'i18nextLng' was i18next's own detection cache, 'platoLanguage' the
    // manual choice. The choice now lives on PlatoUser and arrives with
    // getMe, so stale local values must not shadow it.
    window.localStorage.removeItem('i18nextLng');
    window.localStorage.removeItem('platoLanguage');
}

// Initialize i18next
void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        supportedLngs: supportedLanguages,
        fallbackLng: defaultLanguage,
        defaultNS: 'common',
        load: 'languageOnly',
        detection: {
            order: ['navigator'],
            caches: [],
        },
        // debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        react: {
            useSuspense: false,
        },
    });

i18n.on('languageChanged', (lng) => (document.documentElement.lang = lng));
if (typeof window !== 'undefined') {
    // Init is synchronous (bundled resources), so 'initialized' has already
    // fired before a listener could attach — sync the static index.html
    // lang="de" to the detected language directly.
    document.documentElement.lang = i18n.language;
}

/**
 * Switches the UI to the given language. Purely in-memory: persistence is the
 * server's job (`platoUser.command.settings.update`), and the next load
 * picks the choice up again from getMe.
 */
export function applyLanguage(language: SupportedLanguage): void {
    if (toSupportedLanguage(i18n.language) !== language) {
        void i18n.changeLanguage(language);
    }
}

export { i18n };
